'use client';

import React, { ReactNode } from 'react';
import { useParams } from 'next/navigation';
import { HelpCenterContent } from '@/_components/help-center-content';
import { SearchInput } from '@/_components/search-input';
import { BackButton } from '@/_components/back-button';
import { EPageType } from '@/_analytic/_types';
import { useClientSearchParams } from '@/_hooks/use-client-search-params';
import { getIsSideMode } from '@/_utils';
import { EGoBackOption } from '@/_types/route-params';
import { TRouteCommon } from '@/_constants/routes';
import { AnalyticsWrapper } from '../analytics-wrapper';

type TProps = {
  children: ReactNode;
  canSeeSearch?: boolean;
  pageType?: EPageType;
  backRoute?: string;
};
export const ClientLayout = ({
  children,
  canSeeSearch = true,
  pageType,
  backRoute,
}: TProps) => {
  const searchParams = useClientSearchParams();
  const isSideMode = getIsSideMode(searchParams);
  const { goBackOption } = searchParams;
  const isGoBackMode = goBackOption === EGoBackOption.PREV_ROUTE;

  const { country } = useParams<TRouteCommon>();

  const showBackButton = !!(backRoute && pageType);

  return (
    <AnalyticsWrapper>
      <HelpCenterContent isSideMode={isSideMode}>
        {canSeeSearch && <SearchInput isGridMode />}
        {showBackButton && (
          <BackButton
            backRoute={backRoute}
            country={country}
            isGoBackMode={isGoBackMode}
            pageType={pageType}
            searchParams={searchParams}
          />
        )}
        {children}
      </HelpCenterContent>
    </AnalyticsWrapper>
  );
};
